// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications {
    display: flex;
    /*
    margin: 20px;
    */
    cursor: pointer;
    background-color: #004BA0;
    padding: 11px;
    border-radius: 100%;
}
.notification-pc {
    background: white;
    position: absolute;
    right: 28%;
    top: 74%;
    width: 350px;
    overflow: hidden;
    border-radius: 8px;
    height: 230px;
    z-index: 2;
    box-shadow: 0 4px 8px rgb(0 0 0 / 25%)
}
.notification-pc h3 span {
    cursor: pointer;
    font-size: 12px;
    color: rgb(25, 118, 210);
    position: absolute;
    right: 5%;
    top: 15px;
}
.notification-span {
    background: #FF0000;
    font-size: 12px;
    width: 18px;
    height: 17.5px;
    text-align: center;
    color: white;
    border-radius: 50px;
    margin: -10px;
    position: relative;
    left: 10%;
    bottom: 5px
}
.premium-crown {
    width: 25px;
    height: 25px;
    margin: -10px;
    position: relative;
    left: 50%;
}
.notification-row-container {
    cursor: pointer;
    display: flex;
    padding: 3% 3% 1% 5%;
}
.notification-row-container-effect {
    cursor: pointer;
    display: flex;
    padding: 3% 3% 1% 5%;
    background-color: transparent;
    animation-name: effect;
    animation-duration: 2s;
}
.notification-row-container-slide {
    cursor: pointer;
    display: flex;
    padding: 3% 3% 1% 5%;
    position: relative;
    left: 0;
    animation-name: slide;
    animation-duration: 1s;
}

@keyframes slide {
    100% { left: 100%; }
}
@keyframes effect {
    0%   {background-color: grey;}
}
.notification-row-circle {
    background: #1976D2;
    width: 60px;
    height: 100%;
    border-radius: 100%;
    text-align: center;
    min-width: 50px;
}
.notification-row-text {
    padding: 0 5%;
    width: -webkit-fill-available;
}
.delete-notification {
    width: 12px;
    height: fit-content;
    position: relative;
    right: 2%;
}
.no-notifications {
    width: 100%;
    text-align: center;
    margin: 20% 0;
}
.clearAll {
    color: #1976D2;
    width: 22%;
    font-size: 13px;
    display: flex;
    margin: 1%;
    position: relative;
    left: 75%;
}
.clearAll h4 {
    margin: auto 3px;
}
@media screen and (max-width: 600px) {
    .premium-crown {
        width: 20px;
        height: 20px;
        left: 60%;
        top: -10px;
    }
    .notifications {
        display: flex;
        padding: 0;
        background-color: transparent;
        margin: 20px 5px;
    }
    .notification-span {
        background: #FF0000;
        font-size: 13px;
        width: 17px;
        position: initial;
        height: 17px;
        color: white;
        margin: -8px;
        border: #1976d2 3px solid;
    }
    .no-notifications {
        margin: 70% 0;
    }
    .clearAll {
        color: #1976D2;
        width: auto;
        background: white;
        font-size: 13px;
        border-radius: 10px;
        display: flex;
        margin: 3%;
        position: initial;
    }
    .clearAll h4 {
        margin: auto;
        padding: 0 5px;
        width: max-content;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/builder/css/notification.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb;;KAEC;IACD,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV;AACJ;AACA;IACI,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT;AACJ;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,eAAe;IACf,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,6BAA6B;IAC7B,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,OAAO;IACP,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,OAAO,UAAU,EAAE;AACvB;AACA;IACI,MAAM,sBAAsB,CAAC;AACjC;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,cAAc;IACd,UAAU;IACV,eAAe;IACf,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,UAAU;IACd;IACA;QACI,aAAa;QACb,UAAU;QACV,6BAA6B;QAC7B,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,eAAe;QACf,WAAW;QACX,iBAAiB;QACjB,YAAY;QACZ,YAAY;QACZ,YAAY;QACZ,yBAAyB;IAC7B;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;QACd,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,mBAAmB;QACnB,aAAa;QACb,UAAU;QACV,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,cAAc;QACd,kBAAkB;IACtB;AACJ","sourcesContent":[".notifications {\n    display: flex;\n    /*\n    margin: 20px;\n    */\n    cursor: pointer;\n    background-color: #004BA0;\n    padding: 11px;\n    border-radius: 100%;\n}\n.notification-pc {\n    background: white;\n    position: absolute;\n    right: 28%;\n    top: 74%;\n    width: 350px;\n    overflow: hidden;\n    border-radius: 8px;\n    height: 230px;\n    z-index: 2;\n    box-shadow: 0 4px 8px rgb(0 0 0 / 25%)\n}\n.notification-pc h3 span {\n    cursor: pointer;\n    font-size: 12px;\n    color: rgb(25, 118, 210);\n    position: absolute;\n    right: 5%;\n    top: 15px;\n}\n.notification-span {\n    background: #FF0000;\n    font-size: 12px;\n    width: 18px;\n    height: 17.5px;\n    text-align: center;\n    color: white;\n    border-radius: 50px;\n    margin: -10px;\n    position: relative;\n    left: 10%;\n    bottom: 5px\n}\n.premium-crown {\n    width: 25px;\n    height: 25px;\n    margin: -10px;\n    position: relative;\n    left: 50%;\n}\n.notification-row-container {\n    cursor: pointer;\n    display: flex;\n    padding: 3% 3% 1% 5%;\n}\n.notification-row-container-effect {\n    cursor: pointer;\n    display: flex;\n    padding: 3% 3% 1% 5%;\n    background-color: transparent;\n    animation-name: effect;\n    animation-duration: 2s;\n}\n.notification-row-container-slide {\n    cursor: pointer;\n    display: flex;\n    padding: 3% 3% 1% 5%;\n    position: relative;\n    left: 0;\n    animation-name: slide;\n    animation-duration: 1s;\n}\n\n@keyframes slide {\n    100% { left: 100%; }\n}\n@keyframes effect {\n    0%   {background-color: grey;}\n}\n.notification-row-circle {\n    background: #1976D2;\n    width: 60px;\n    height: 100%;\n    border-radius: 100%;\n    text-align: center;\n    min-width: 50px;\n}\n.notification-row-text {\n    padding: 0 5%;\n    width: -webkit-fill-available;\n}\n.delete-notification {\n    width: 12px;\n    height: fit-content;\n    position: relative;\n    right: 2%;\n}\n.no-notifications {\n    width: 100%;\n    text-align: center;\n    margin: 20% 0;\n}\n.clearAll {\n    color: #1976D2;\n    width: 22%;\n    font-size: 13px;\n    display: flex;\n    margin: 1%;\n    position: relative;\n    left: 75%;\n}\n.clearAll h4 {\n    margin: auto 3px;\n}\n@media screen and (max-width: 600px) {\n    .premium-crown {\n        width: 20px;\n        height: 20px;\n        left: 60%;\n        top: -10px;\n    }\n    .notifications {\n        display: flex;\n        padding: 0;\n        background-color: transparent;\n        margin: 20px 5px;\n    }\n    .notification-span {\n        background: #FF0000;\n        font-size: 13px;\n        width: 17px;\n        position: initial;\n        height: 17px;\n        color: white;\n        margin: -8px;\n        border: #1976d2 3px solid;\n    }\n    .no-notifications {\n        margin: 70% 0;\n    }\n    .clearAll {\n        color: #1976D2;\n        width: auto;\n        background: white;\n        font-size: 13px;\n        border-radius: 10px;\n        display: flex;\n        margin: 3%;\n        position: initial;\n    }\n    .clearAll h4 {\n        margin: auto;\n        padding: 0 5px;\n        width: max-content;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
